// $(document).ready(function(){
//       $('.collection-slider .owl-carousel').owlCarousel({
//         loop: true,
//         margin: 45,
//         dots: true,
//         nav: false,
//         responsive: {
//           0: {
//             items: 1
//           },
//           576: {
//             items: 2
//           },
//           992: {
//             items: 3
//           }
//         }
//       });
//     });

$(document).ready(function () {
  setTimeout(function () {
    $('.collection-slider .owl-carousel').owlCarousel({
      loop: true,
      margin: 45,
      dots: true,
      nav: false,
      autoplay: true,
      autoplaySpeed: 1000,
      smartSpeed: 800,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      responsive: {
        0: {
          items: 1
        },
        576: {
          items: 2
        },
        992: {
          items: 3
        }
      }
    });
  }, 100); 
});

document.addEventListener("DOMContentLoaded", function () {
  var containers = [".product-information"];
  containers.forEach(function (container) {
    var $detailsList = document.querySelectorAll(container + " details");
    $detailsList.forEach(function (detail) {
      if (!detail.hasAttribute("open")) {
        var content = detail.querySelector(".details-content");
        if (content) {
          content.style.display = "none";
        }
      }
    });
    document.querySelectorAll(container + " summary").forEach(function (summary) {
      summary.addEventListener("click", function (e) {
        e.preventDefault();
        var details = summary.parentElement;
        var content = details.querySelector(".details-content");
        if (details.hasAttribute("open")) {
          if (content) {
            $(content).stop(true, true).slideUp(400, function () {
              details.removeAttribute("open");
            });
          } else {
            details.removeAttribute("open");
          }
        } else {
          document.querySelectorAll(container + " details[open]").forEach(function (openDetails) {
            openDetails.removeAttribute("open");
            var openContent = openDetails.querySelector(".details-content");
            if (openContent) {
              $(openContent).slideUp(400);
            }
          });
          details.setAttribute("open", true);
          if (content) {
            $(content).stop(true, true).slideDown(400);
          }
        }
      });
    });
  });
});